const BASE64_PAD_CHAR = '='

/**
 * UTF-8 字符串转 Base64
 */
export function encodeBase64Utf8(value: string): string {
  if (!value) return ''

  const bytes = new TextEncoder().encode(value)
  let binary = ''
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte)
  })

  return btoa(binary)
}

/**
 * Base64 转 UTF-8 字符串
 */
export function decodeBase64Utf8(value: string): string {
  if (!value) return ''

  const binary = atob(value)
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0))
  return new TextDecoder().decode(bytes)
}

/**
 * UTF-8 字符串转 URL 安全 Base64（去掉 = 补位）
 */
export function encodeBase64UrlUtf8(value: string): string {
  return encodeBase64Utf8(value).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '')
}

/**
 * URL 安全 Base64 转 UTF-8 字符串
 */
export function decodeBase64UrlUtf8(value: string): string {
  if (!value) return ''

  const base64 = value.replace(/-/g, '+').replace(/_/g, '/')
  const remainder = base64.length % 4
  const paddedBase64 = remainder ? `${base64}${BASE64_PAD_CHAR.repeat(4 - remainder)}` : base64

  return decodeBase64Utf8(paddedBase64)
}
